import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { AnnouncerService } from '../../services/announcer.service';

@Injectable()
export class AppTitleStrategy extends TitleStrategy {
  private static readonly appName = 'Headcount';
  private lastAnnounced?: string;

  constructor(
    private readonly title: Title,
    private readonly announcer: AnnouncerService
  ) {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const pageTitle = this.resolvePageTitle(snapshot.root) ?? this.buildTitle(snapshot);
    this.title.setTitle(pageTitle ? `${pageTitle} · ${AppTitleStrategy.appName}` : AppTitleStrategy.appName);

    if (pageTitle && pageTitle !== this.lastAnnounced) {
      this.lastAnnounced = pageTitle;
      this.announcer.announce(pageTitle);
    }
  }

  private resolvePageTitle(root: ActivatedRouteSnapshot): string | undefined {
    let route: ActivatedRouteSnapshot | null = root;
    let displayTitle: string | undefined;

    while (route) {
      const routeDisplayTitle = route.data?.['displayTitle'] as string | undefined;
      if (routeDisplayTitle) {
        displayTitle = routeDisplayTitle;
      }
      route = route.firstChild;
    }

    return displayTitle;
  }
}
